import React from 'react';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import RolesDropdown from '@/roles/containers/RolesDropdown';
import { states } from '@/constants/lifecycle';
import Filter from '@/components/Filter';
import { fetchUsers, updateUsersFilter, updateUsersRoleFilter } from '../actions';
import UsersFilterToggles from './UsersFilterToggles';

const UsersFilters = ({
  allowRoleLink,
  category,
  className,
  fetchData,
  filterTerm,
  fluid,
  readErrors,
  readStatus,
  roleName,
  updateFilterTerm,
  updateFilterRole,
}) => {
  const filterComponent = (
    <Filter
      className={fluid ? 'aridhia-list-filter' : undefined}
      error={firstErrorMessage(readErrors)}
      filterTerm={filterTerm}
      fluid={fluid}
      label={<UsersFilterToggles category={category} />}
      onFilter={() => fetchData(category, 1, null, false)}
      updateFilter={({ value }) => updateFilterTerm(category, value)}
    />
  );
  const dropDownComponent = (
    <RolesDropdown
      byName
      category="users"
      className={fluid ? 'mt-5' : 'mr-10'}
      clearable
      disabled={readStatus === states.PENDING}
      fluid={fluid}
      onChange={(e, { value }) => updateFilterRole(category, value)}
      placeholder="roles.filter.placeholder"
      value={roleName}
    />
  );
  const components = { first: allowRoleLink ? dropDownComponent : null, second: filterComponent };
  if (allowRoleLink && fluid) {
    components.first = filterComponent;
    components.second = dropDownComponent;
  }

  return (
    <div className={`aridhia-users-filters ${className}`}>
      {components.first && (<>{components.first}</>)}
      {components.second && (<>{components.second}</>)}
    </div>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions }, users },
}, { category }) => {
  const item = users[category];
  return {
    allowRoleLink: permissions.roles.read,
    filterTerm: item.filter,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    roleName: item.role,
  };
};

const mapDispatchToProps = {
  fetchData: fetchUsers,
  updateFilterTerm: updateUsersFilter,
  updateFilterRole: updateUsersRoleFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersFilters);
